<template>
  <div class="introduce">
    <div class="introduceList">
      <div class="top">我的当前积分：<span>{{info.data.teacher.points}}分</span></div>
      <div class="list">
        <ul v-for="(item,index) in record" :key="index">
          <div class="time">{{item.day_time}}</div>
          <li v-for="(items, indexs) in item.list" :key="indexs">
            <span class="fl">{{items.resource}}</span>
            <sapm class="fr">
              <span v-if=" items.type === 1 ">+</span>
              <span v-if=" items.type === 2 ">-</span>
              {{items.points}}
            </sapm>
          </li>
        </ul>
      </div>
    </div>

    <div style="clear: both;"></div>
    <div class="page">
      <el-pagination
        background
        layout="prev, pager, next"
        @current-change="pageChange"
        :total="info.count">
      </el-pagination>
    </div>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        info: {},
        page: 1,
        record: {}
      }
    },
    created () {
      this.getmypoints()
    },
    methods: {
      pageChange (page) {
        this.page = page
        this.getmypoints()
      },
      getmypoints () {
        this.$http.post('/apipx/Personal/mypoints', {
          p: this.page,
          row: 10,
          token: JSON.parse(localStorage.getItem('login')).token
        }).then(res => {
          if (res.code === 0) {
            this.info = res
            this.record = res.data.record
          }
        })
      }
    }
  }
</script>

<style type="text/scss" lang="scss">
  .introduce {

    .introduceList {
      padding: 35px;
      background-color: #fff;
      border-radius: 35px;
      box-shadow: 0px 0px 20px #e2e0e0;

      .top {
        span {
          color: #ff827b;
          font-size: 16px;
        }
      }

      .list {
        ul {
          margin-top: 10px;

          .time {
            font-size: 16px;
            color: #b1b1b1;
            height: 50px;
            line-height: 50px;
          }

          li {
            height: 50px;
            line-height: 50px;

            .fr {
              color: #ff827b;
              font-weight: bold;
            }
          }
        }
      }
    }

    .page {
      height: 35px;
      margin: 50px auto 0;

      .el-pagination {
        width: 500px;
        margin: 0 auto;
      }

      .el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev, .el-pagination.is-background .el-pager li {
        border-radius: 50%;
        min-width: 33px;
        min-height: 33px;
        line-height: 33px;
        margin: 0 8px;

        &:hover {
          color: #ff8484;
        }
      }

      .el-pagination.is-background .el-pager li:not(.disabled).active {
        background-color: #ff8484;
        color: #FFF;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/userInfo/integral/introduce/introduce.vue